import { useEffect } from "react";
import { useSpring, animated } from "@react-spring/web";

export type DateValueTextProps = {
  dateValue: string | undefined;
};

export function DateValueText(props: DateValueTextProps) {
  const { dateValue } = props;

  const [shimmerStyles, shimmerApi] = useSpring(() => ({
    from: { x: -100 },
    config: { tension: 280, friction: 60 }
  }));

  useEffect(() => {
    shimmerApi.start({
      from: { x: -100 },
      to: { x: 100 },
      config: { duration: 1000 }
    });
  }, [dateValue, shimmerApi]);

  return (
    <span className="relative inline-flex overflow-hidden">
      {dateValue}
      <animated.span
        className="pointer-events-none absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent"
        style={{
          transform: shimmerStyles.x.to(x => `translateX(${x}%)`)
        }}
      />
    </span>
  );
}
